import RoutesPath from '@router/routes';

const routes = [
  {
    path: RoutesPath.private.advertisements.list,
    label: 'Lista de publicidades',
  },
  {
    path: RoutesPath.private.advertisements.detail,
    label: 'Detalhes da publicidade',
  },
];

export default routes;
